/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { FC, Fragment, ReactNode, useEffect, useState } from "react"
import { useTranslationsMap } from "common/utils/i18n"
import { Modal, Checkbox, Divider } from "@duxton-web/ui"
import { ModalProps } from "@duxton-web/ui/es/modal"
import { modalStyle, modalFooterRightStyle } from "./styles"

interface ConfirmModalV2Props extends ModalProps {
  icon?: ReactNode
  message?: string
  description?: string
  agreementMessage?: string
}

export const ConfirmModalV2: FC<ConfirmModalV2Props> = ({
  icon,
  message,
  description,
  agreementMessage,
  okButtonProps,
  open,
  ...props
}: ConfirmModalV2Props) => {
  const textMap = useTranslationsMap({
    defaultCancelText: "menu.buttons.cancel",
  })

  const [isAgree, setIsAgree] = useState(false)

  // Uncheck agreement when confirm modal hidden
  useEffect(() => {
    if (!open) {
      setIsAgree(false)
    }
  }, [open])

  return (
    <Modal
      title={
        <div>
          <div
            css={css`
              margin-bottom: 15px;
            `}
          >
            {icon && icon}
          </div>
          {message}
        </div>
      }
      width={600}
      css={css`
        ${modalStyle}
        ${modalFooterRightStyle}
      `}
      cancelText={textMap.defaultCancelText}
      okButtonProps={{
        disabled: !!agreementMessage && !isAgree,
        ...okButtonProps,
      }}
      open={open}
      {...props}
    >
      {description}
      {agreementMessage && (
        <Fragment>
          <Divider />
          <Checkbox
            checked={isAgree}
            onChange={e => setIsAgree(e.target.checked)}
          >
            {agreementMessage}
          </Checkbox>
        </Fragment>
      )}
    </Modal>
  )
}
